<template>
    <v-layout row wrap >
        <v-flex xs12>
            
            <h3 style="padding-left: 15px;">{{dialogData.titulo}}</h3>
        </v-flex>
        <v-flex xs12>
            <commentList/>
        </v-flex>
        <v-flex xs3 offset-xs9>
            <v-btn 
                color="primary"
                flat
                @click="back()"
            >
                Atras
            </v-btn>
            <v-btn v-if="$store.state.visitaSinPedido"
                color="green"
                flat
                @click="noOrderOk()"
            >
                Confirmar
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
import commentList from '@/components/commentList.vue'
export default {
    name: 'cardTodoNoOrder',
    data() {
        return{

        }
    },
    methods: {
        back(){
            if (this.$router.currentRoute.path == '/comentarios'){
                this.$store.state.visitaComentarios = false;
                this.$router.push('pedido');
            } else {
                if (this.$store.state.visitaComentarios)
                    this.$store.state.visitaComentarios = false;
                else 
                    this.$router.push('rutas');
            }
        },
        noOrderOk(){
            if (this.$router.currentRoute.path == '/comentarios'){
                this.$store.state.visitaComentarios = false;
                this.$router.push('pedido');
            } else {
                if (this.$store.state.visitaComentarios)
                    this.$store.state.visitaComentarios = false;
                else {
                    //console.log(this.dialogData);
                    this.visitaSinPedido(this.dialogData.event.no);
                    this.dialog = false;
                }
            }
        },
    },
    computed:{
        dialogData: {
            get(){
                console.log(this.$store.state.calEventDialogData);
                return this.$store.state.calEventDialogData;
            }
        },
    },
    components: {
        commentList
    }

}
</script>

<style>

</style>